import axios from "axios";
import {
  ASSIGN_MAIN_JOB_TO_SUB_PROGRAMS_URL,
  DELETE_ENTITY_TYPE_URL,
  GET_MAIN_JOB_SUB_PROGRAM_ASSIGNMENTS_URL,
  LIST_SUB_PROGRAMS_URL,
} from "@/utils/constants/constants.js";

export default {
  methods: {
    select_selected_job_for_archive() {
      const original = this.get_selected_job_action_row();
      if (!original) return;
      this.select_job_for_archive({ __row_id: original.id, "Job Profile": original.entity_type_name });
    },
    open_selected_job_archive_modal() {
      this.select_selected_job_for_archive();
      this.close_job_action_menu();
      this.show_modal("archive_job_profile_modal");
    },
    select_job_for_archive(row) {
      const target = this.resolve_job_action_target(row);
      this.archive_job_profile_id = target.original?.id || target.entity_type_id;
      this.archive_job_profile_name = target.name;
      this.archive_job_profile_loading = false;
    },
    archive_job_profile() {
      if (!this.archive_job_profile_id) return Promise.resolve();
      this.archive_job_profile_loading = true;
      return axios.post(
        DELETE_ENTITY_TYPE_URL,
        { entity_type_id: this.archive_job_profile_id },
        { headers: this.headers, withCredentials: true }
      ).then(async (response) => {
        if (response.data.status !== "success") {
          this.show_error(response.data.message || "Failed to archive job profile.");
          return;
        }
        this.show_success("Job profile deleted successfully.");
        this.close_modal("archive_job_profile_modal");
        this.archive_job_profile_id = null;
        this.archive_job_profile_name = "";
        await this.view_created_trust_type();
      }).catch((err) => {
        this.show_error(err?.response?.data?.message || "Failed to archive job profile.");
      }).finally(() => {
        this.archive_job_profile_loading = false;
      });
    },
    redirect_to_view_entity(entity_type_id) {
      this.open_job_profile_route(entity_type_id, "Job Adverts");
    },
    clear_sub_program_context() {
      sessionStorage.removeItem("sub_program_id");
      sessionStorage.removeItem("sub_program_name");
      sessionStorage.removeItem("sub_program_context");
      this.active_sub_program_id = null;
      this.active_sub_program_name = null;
      this.view_created_trust_type();
    },
    async open_assign_main_job_modal(row) {
      this.assign_job_modal_entity_type_id = row.id;
      this.assign_job_modal_selected_sub_program_ids = [];
      this.assign_job_modal_sub_programs = [];
      const project_id = parseInt(this.project_id, 10);
      if (!project_id) return;
      await axios.get(LIST_SUB_PROGRAMS_URL, {
        headers: this.headers,
        params: { project_id },
      }).then((response) => {
        this.assign_job_modal_sub_programs = response.data.status === "success" ? (response.data.data || []) : [];
      }).catch(() => {
        this.assign_job_modal_sub_programs = [];
      });
      await axios.post(
        GET_MAIN_JOB_SUB_PROGRAM_ASSIGNMENTS_URL,
        { entity_type_id: row.id },
        { headers: this.headers, withCredentials: true }
      ).then((response) => {
        this.assign_job_modal_selected_sub_program_ids = response.data.status === "success"
          ? (response.data.data?.sub_program_ids || [])
          : [];
      }).catch(() => {
        this.assign_job_modal_selected_sub_program_ids = [];
      });
    },
    save_main_job_sub_program_assignments() {
      if (!this.assign_job_modal_entity_type_id) return Promise.resolve();
      return axios.post(
        ASSIGN_MAIN_JOB_TO_SUB_PROGRAMS_URL,
        {
          entity_type_id: this.assign_job_modal_entity_type_id,
          sub_program_ids: this.assign_job_modal_selected_sub_program_ids,
        },
        { headers: this.headers, withCredentials: true }
      ).then(async (response) => {
        if (response.data.status !== "success") {
          this.show_error(response.data.message || "Failed to save assignments.");
          return;
        }
        this.show_success("Job sub-program assignments updated successfully.");
        this.close_modal("assign_main_job_sub_programs_modal");
        await this.view_created_trust_type();
      }).catch((err) => {
        this.show_error(err?.response?.data?.message || "Failed to save assignments.");
      });
    },
  },
};
